// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"40":"0a15cee0","67":"48e3b380","316":"5c16be42","364":"f9be83b4","371":"dea7bd73","423":"92f160be","478":"5ee74e4c","642":"efacaa3c","707":"cd12ba7b","732":"678f45a6","750":"bbeeccda","795":"40f698f5","893":"ee5b5b29","923":"642de1a0","966":"76fa5d47"}[chunkId] + ".js";
};